/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-17
 * @description Manages the languages informations and listings
 */
import React, { useState } from "react";
import { Box } from "@mui/material";

import { LanguageList } from "./LanguageList";
import { HeaderSection } from "./HeaderSection";
import { useFetchData } from "../../../components/hooks/useFetchData";

const Languages = () => {
  const [minLoading, setMinLoading] = useState(true);
  const [languageList, setLanguageList] = useState([]);

  const { fetchData, loading } = useFetchData();

  const getAllLanguage = async () => {
    const result = await fetchData("getlanguages?showActive=0");
    if (result?.code === 200) {
      setLanguageList(result.data);
    }
  };

  React.useEffect(() => {
    getAllLanguage();
    const minLoadingTimer = setTimeout(() => {
      setMinLoading(false);
    }, 1500);

    return () => clearTimeout(minLoadingTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading = minLoading || loading["getlanguages?showActive=0"];

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        overflow="hidden"
      >
        <HeaderSection isLoading={isLoading} />
        <LanguageList languages={languageList} isLoading={isLoading} />
      </Box>
    </>
  );
};
export default Languages;
